import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const propTypes = {
  player: PropTypes.object,
  className: PropTypes.string,
};

export default function AudioVisualizer({ player, player: { currentTime, hasStarted, waiting, contentLoading, videoWidth, videoHeight }, className }) {

  if (!hasStarted ||
    waiting ||
    contentLoading ||
    !currentTime ||
    !(videoWidth === 0 && videoHeight === 0)) {
    return null;
  }

  return (
    <div
      className={classNames(
        'video-react-audio-visualizer',
        className
      )}
    >
      <div className="halo"></div>
    </div>
  );
}

AudioVisualizer.propTypes = propTypes;
AudioVisualizer.displayName = 'AudioVisualizer';
